import { dividendsHistoryTableHead } from './constants';

export const getFlex = (index: number) => {
  return dividendsHistoryTableHead[index].flex;
};
